import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaChartBar, FaPalette, FaGamepad } from 'react-icons/fa';

const AdminSubNav = () => {
  const location = useLocation();

  const links = [
    { path: '/bs', icon: <FaChartBar />, label: 'Stats' },
    { path: '/logo-creator', icon: <FaPalette />, label: 'Logo Creator' },
    { path: '/retro-arcade', icon: <FaGamepad />, label: 'Retro Arcade' },
  ];

  return (
    <nav className="sticky top-24 z-30 bg-[#F8F7F4]/90 backdrop-blur-xl border-b border-black/[0.08]">
      <div className="container mx-auto px-4 max-w-[920px]">
        <div className="flex items-center gap-4 h-12">
          {links.map(({ path, icon, label }) => (
            <Link 
              key={path}
              to={path}
              className="block"
            >
              <motion.div 
                className={`flex items-center gap-2 px-3 py-1.5 rounded-lg transition-colors ${
                  location.pathname === path 
                    ? 'bg-black/[0.05] text-black/60' 
                    : 'text-black/40 hover:text-black/60'
                }`}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <span className="w-4 h-4">{icon}</span>
                <span className="font-['VT323'] text-[16px]">{label}</span>
              </motion.div>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default AdminSubNav; 